import { UploadInputChildrenProps, UploadInputProps } from "../UploadInput.types";

export default function renderUploadInputChildren(
    children: UploadInputProps["children"],
    params: UploadInputChildrenProps,
): React.ReactNode {
    if (typeof children === "function") {
        return children(params);
    }
    return children;
}
